<template>
  <div class="notice">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="notice" class="iconstyle"></svg-icon>通知公告
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="news" v-if="!showNoMessageImg">
        <li class="ft12" v-for="(item,index) in dataFeed" :key="index" @click="toDetail(item)">
          <span class="title ub-f1" :title="item.MianTitle">{{item.MianTitle}}</span>
          <span class="time">{{item.PubTime|formatDate('yyyy-MM-dd')}}</span>
        </li>
      </div>
      <div class="Img" v-if="showNoMessageImg">
        <img src="@/components/indexnew/img/noMessage.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { ArticleControllerSvr } from '@/service/ArticleControllerSvr.js';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      dataFeed: [],
      showNoMessageImg: true
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.ArticleControllerSvr = new ArticleControllerSvr();
  },
  mounted() {
    this.getdate();
  },
  methods: {
    jumpMore() {
      this.$router.push({ path: 'noticeMore' });
    },
    getdate() {
      //1 通知公告
      //2 最新动态
      const myworkLoading = this.$loading({
        target: document.querySelector('.news')
      });
      this.ArticleControllerSvr.getArticleListByCategoryCodes(
        this.token,
        '002001,012001,011006',
        '',
        0,
        5,
        false
      )
        .then(res => {
          this.dataFeed = res._Items;
          this.showNoMessageImg = false;
          myworkLoading.close();
        })
        .catch(() => {
          myworkLoading.close();
        });
    },
    toDetail(item) {
      this.$router.push({
        path: 'notice',
        query: {
          item: JSON.stringify(item)
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './css/common.scss';
.notice {
  background: #fff;
  .iconstyle {
    font-size: 18px;
    margin: 0 6px;
    color: #ffb11a;
  }
  .container {
    height: 140px;
    padding: 10px 0;
    overflow: hidden;
    .Img {
      padding: 5px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .news {
      li {
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        height: 40px;
        font-size: 14px;
        box-sizing: border-box;
        line-height: 30px;
        cursor: pointer;
        .title {
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 6px;
          .hot {
            display: inline-block;
            position: relative;
            top: -4px;
            height: 7px;
            width: 18px;
            background: #ff4546;
            img {
              position: absolute;
              top: 0;
            }
          }
        }
        &:nth-child(2n) {
          background: #f7f8fa;
        }
        &:hover {
          background: #e3f0ff;
        }
      }
    }
  }
}
</style>